import moment from 'moment-timezone';

import { EventsFilter } from '../interfaces';
import { EventTypeIdentifier, FleetUUIDs, VideoStatus } from '../enums';
import { tagIdentifierFilterKey, tagVariantIdentifierFilterValue } from '../utils/tagFilters';
import { SACRT_DEFAULT_FILTER_TAGS } from './sacrtTags';

export const defaultFilter = (): EventsFilter => ({
  dateFrom: moment().subtract(1, 'week').startOf('day').toISOString(),
  dateTo: moment().toISOString(),
  selectedFilters: [],
  license_plates: [],
  time_of_day: [0, 24],
  vehicle_types: [],
  active_lanes: [],
  route_ids: [],
  vehicle_ids: [],
  bus_stop_ids: [],
  device_ids: [],
});

export const fleetDefaultFilters = (fleetUUID: FleetUUIDs): EventsFilter => {
  const base = defaultFilter();

  if ([FleetUUIDs.MTA, FleetUUIDs.MTAReplay].includes(fleetUUID)) {
    return {
      ...base,
      selectedFilters: [EventTypeIdentifier.BUS_LANE_MATCH],
      human_review: true,
      media_statuses: [VideoStatus.publishedStr],
      whitelist: false,
    };
  }

  if (fleetUUID === FleetUUIDs.Chicago) {
    return {
      ...base,
      dateFrom: moment().subtract(14, 'day').startOf('day').toISOString(),
    };
  }

  if ([FleetUUIDs.SacRTBusStopShelter, FleetUUIDs.SacRTBusStopShelterActivePilot].includes(fleetUUID)) {
    return {
      ...base,
      dateFrom: moment().subtract(24, 'hours').toISOString(),
      include_tags: true,
      tag_operator: 'or',
      // Keyed and valued by identifier, so nothing here is tied to one environment's numeric IDs.
      // The backend resolves both halves (CLOUD-9960).
      tags: Object.fromEntries(
        SACRT_DEFAULT_FILTER_TAGS.map((identifier) => [
          tagIdentifierFilterKey(identifier),
          tagVariantIdentifierFilterValue(identifier),
        ]),
      ),
    };
  }

  return base;
};

export const fleetCleanFilters = (fleetUUID: FleetUUIDs): EventsFilter => {
  const base = defaultFilter();

  if ([FleetUUIDs.SacRTBusStopShelter, FleetUUIDs.SacRTBusStopShelterActivePilot].includes(fleetUUID)) {
    return {
      ...base,
      include_tags: true,
    };
  }

  return base;
};
